import { render, staticRenderFns } from "./keyWordImport.vue?vue&type=template&id=36400902&scoped=true&"
import script from "./keyWordImport.vue?vue&type=script&lang=js&"
export * from "./keyWordImport.vue?vue&type=script&lang=js&"
import style0 from "./keyWordImport.vue?vue&type=style&index=0&id=36400902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36400902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36400902')) {
      api.createRecord('36400902', component.options)
    } else {
      api.reload('36400902', component.options)
    }
    module.hot.accept("./keyWordImport.vue?vue&type=template&id=36400902&scoped=true&", function () {
      api.rerender('36400902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/keyWordImport.vue"
export default component.exports